import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { HashtagMentionTypeEnum } from 'redux-store/api/activity-feed/hashtags.types';

export interface IHashtagSlice {
  projectId: number | null;
  hashtagType: HashtagMentionTypeEnum | null;
  selectionItemId: number | null;
  phaseItemId: number | null;
  fileItem: {
    id: number;
    mimeType: string;
  };
}

const initialState: IHashtagSlice = {
  projectId: null,
  hashtagType: null,
  selectionItemId: null,
  phaseItemId: null,
  fileItem: null,
};

type HashtagMetadataPayload =
  | {
      hashtagType: HashtagMentionTypeEnum.selection | HashtagMentionTypeEnum.selectionOption;
      selectionItemId: number;
      projectId: number;
    }
  | { hashtagType: HashtagMentionTypeEnum.phaseItem; phaseItemId: number; projectId: number }
  | {
      hashtagType: HashtagMentionTypeEnum.fileCabinetItem;
      fileItemId: number;
      mimeType: string;
      projectId: number;
    };

export const hashtagSlice = createSlice({
  name: 'hashtag',
  initialState,
  reducers: {
    setHashtagMetadata: (state, action: PayloadAction<HashtagMetadataPayload>) => {
      Object.assign(state, initialState);

      const { hashtagType, projectId } = action.payload;
      state.hashtagType = hashtagType;
      state.projectId = projectId;

      switch (hashtagType) {
        case HashtagMentionTypeEnum.selection:
        case HashtagMentionTypeEnum.selectionOption:
          state.selectionItemId = action.payload.selectionItemId;
          break;

        case HashtagMentionTypeEnum.phaseItem:
          state.phaseItemId = action.payload.phaseItemId;
          break;

        case HashtagMentionTypeEnum.fileCabinetItem:
          state.fileItem = {
            id: action.payload.fileItemId,
            mimeType: action.payload.mimeType,
          };
          break;

        default:
          break;
      }
    },

    clearHashtagMetadata: () => initialState,
  },
});

export const { setHashtagMetadata, clearHashtagMetadata } = hashtagSlice.actions;

export default hashtagSlice.reducer;
